import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { canonicalPath } from '../hooks/useSEO';

// Redirects /Transfers/ → /transfers (lowercase, no trailing slash) so every URL has one crawlable form.
const PathNormalizer = () => {
  const { pathname, search, hash } = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    const norm = canonicalPath(pathname);
    if (norm !== pathname && !pathname.startsWith('/api')) navigate(`${norm}${search}${hash}`, { replace: true });
  }, [pathname, search, hash, navigate]);
  return null;
};

export default PathNormalizer;
